<template>
  <div>
    <div id='video-container'>
      <div id='video'></div>
    </div>
    <div @click='toggleVideo' id='video-overlay'></div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import YouTubePlayer from 'youtube-player'

export default {
  name: 'video',
  data() {
    return {
      player: {},
      title: '',
      image: ''
    }
  },
  methods: {
    ...mapActions(['SET_SINGLE']),
    setSingleActionWrapper() {
      this.SET_SINGLE(this.main.works.find(e => e.slugs[0] === this.$route.params.slug))
    },
    toggleVideo() {
      this.$emit('hideNav')
      if (this.player.getPlayerState) {
        this.player.getPlayerState().then(state => {
          // 1 === playing
          if (state === 1) {
            this.player.pauseVideo()
          } else {
            this.player.playVideo()
          }
        })
      }
    }
  },
  head: {
    title() {
      return {
        inner: this.title
      }
    },
    meta() {
      return [
        {
          property: 'og:image',
          content: this.image
        }
      ]
    }
  },
  computed: {
    ...mapState(['main'])
  },
  mounted() {
    if (this.main.works && this.main.works.length > 0) {
      this.setSingleActionWrapper()
    }
  },
  watch: {
    'main.works'() {
      this.setSingleActionWrapper()
    },
    $route(to, from) {
      this.setSingleActionWrapper()
    },
    'main.single.data.video.embed_url'() {
      // Destroy the player, if it already exists
      if (this.player.destroy) {
        this.player.destroy()
      }
      // Initialize player
      this.player = YouTubePlayer('video', {
        playerVars: {
          controls: 0,
          loop: true,
          modestbranding: 0,
          showinfo: 1,
          rel: 0
        }
      })
      // Slice off the last 11 characters to get the ID
      this.player.loadVideoById(
        this.main.single.data.video.embed_url.substr(this.main.single.data.video.embed_url.length - 11)
      )
      // Play video
      this.player.playVideo()

      // Play next video when finished
      this.player.on('stateChange', event => {
        // 0 === video ended
        if (event.data === 0) {
          let i = 0
          if (this.main.single.data.order !== this.main.works.length) {
            i = this.main.single.data.order
          }
          console.log(i)
          this.$router.push(this.main.works[i].slugs[0])
        }
      })

      // Set title
      this.title = this.main.single.data.title[0].text
      if (this.main.single.data.preview_image) {
        this.image = this.main.single.data.preview_image.url
      }
      this.$emit('updateHead')
    }
  }
}
</script>

<style lang='scss'>
@import '../style/helpers/_mixins.scss';
@import '../style/helpers/_responsive.scss';
@import '../style/helpers/_reset.css';
@import '../style/_variables.scss';

#video-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2;
  cursor: pointer;
  @include screen-size('small') {
    width: 100vw;
    height: 100vh;
  }
}

#video-container {
  width: 100vw;
  height: 100vh;

  iframe {
    width: 100%;
    height: 100%;
  }
  @include screen-size('small') {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 35px;
    height: 0;
    overflow: hidden;
    @include center;
    top: 45%;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// video.vue?44ec52ce